import { Badge } from "reactstrap";
import i18n from "../../../i18n";

const STATUS_COLORS = {
  draft: 'secondary',
  approved: 'info',
  paid: 'success',
  cancelled: 'danger'
};

export function printPayrollStatus(status) {
  const color = STATUS_COLORS[status] || 'dark';
  return <Badge color={color}>{i18n.t(`hr.payrollRun.status.${status}`)}</Badge>;
}

/**
 * Mirrors the transitions enforced by PayrollRunController, so the UI only
 * offers actions the API will actually accept.
 */
const ALLOWED_TRANSITIONS = {
  draft: ['approved', 'cancelled'],
  approved: ['paid', 'cancelled'],
  paid: [],
  cancelled: []
};

export function canTransitionTo(current, next) {
  return (ALLOWED_TRANSITIONS[current] || []).includes(next);
}

export function isEditable(status) {
  return status === 'draft';
}

export const formatMoney = (amount, currency = '') =>
  `${(Number(amount) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}${currency ? ` ${currency}` : ''}`;
